import { render, staticRenderFns } from "./pressureinfo.vue?vue&type=template&id=c0bcfd1a&"
import script from "./pressureinfo.vue?vue&type=script&lang=ts&"
export * from "./pressureinfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pressureinfo.vue"
export default component.exports